import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { GetPaymentProviderCvvSession } from '../../api/services/pms';
import PropTypes from "prop-types";

/**
 * BridgerPayCvv component
 * create iframe to CVV using bridger pay provider
 * THe hotel must have BridgerPay provider
 * It auto get cvv session from api
 * In save can make useImperativeHandle get CVV to get data
 */
const BridgerPayCvv = forwardRef(({ HotelId, session, guestId }, ref) => {

    const [bloxController, setBloxController] = useState(null);

    const cvvInputRef = ref;

    const initializeBloxController = async (HotelID, guestId) => {
        const BP = window.BP;
        if (!BP) {
            console.error('BridgerPay SDK not loaded');
            return;
        }

        if(bloxController) {
            return;
        }

        if(!session) {
            const sessionModel = await GetPaymentProviderCvvSession({ HotelID, GuestId :guestId });
            session = sessionModel.SessionId;
        }

        const controller = new BP.BloxController({
            token: session,
            fontsSources: ['https://fonts.googleapis.com/css?family=Poppins:wght@100;300;400;500;600;700'],
            style: {
                base: {
                    font: "16px/1.2 'Poppins', 'Arial', 'Helvetica Neue', 'Helvetica', sans-serif",
                    color: 'black',
                    'font-size': '14px',
                    height: '14px',
                    ':focus': {
                        color: 'black',
                    },
                    '::placeholder': {
                        color: 'black',
                        opacity: 1
                    }
                },
                empty: {
                    font: "16px/1.2 'Poppins', 'Arial', 'Helvetica Neue', 'Helvetica', sans-serif",
                    color: 'black',
                    'font-size': '14px',
                    height: '14px',
                    ':focus': {
                        color: 'black',
                    },
                    '::placeholder': {
                        color: 'black',
                        opacity: 1
                    }
                },
                invalid: {
                    color: '#cf1b58',
                    'font-size': '14px',
                    height: '14px',
                },
            },
        });

        const cardCvv = controller.createBlox('cardCvv', {
            placeholder: '---',
            umaskedCvv: false,
            cvvLength: 4
        });

        cardCvv.on(
            'change',
            ({ error }) => error ? console.error('cardCvv', error) : console.log('cardCvv is Valid')
        );

        cardCvv.on(
            'validate',
            ({ error }) => error ? console.error('cardCvv', error) : console.log('cardCvv is Valid')
        );

        await cardCvv.mount('#cvv .input');

        setBloxController(controller);
    };

    useEffect(() => {
        initializeBloxController(HotelId, guestId);
    }, [HotelId, guestId]);

    const getCvv = async () => {
        if (!bloxController) {
            console.error('BloxController not initialized');
            return;
        }

        if (bloxController.isAllValid === false) {
            bloxController.validateAll();
            return;
        }
        
        const result = await bloxController.encryptCvv();
        console.log('The cvv response is', result);
        return result.encryptedCvv;
    };

    useImperativeHandle(ref, () => ({
        getCvv: () => {
            return getCvv();
        }
    }));

    return (
        <div className="cvv-container">
            <div id="cvv" className="field">
                <label className="cvv-label">CVV</label>
                <div className="input" ref={cvvInputRef}></div>
            </div>
        </div>
    );
});

BridgerPayCvv.displayName = 'BridgerPayCvv'
BridgerPayCvv.propTypes = {
    HotelId: PropTypes.number,
    session: PropTypes.string,
    guestId: PropTypes.number,
}

export default BridgerPayCvv;